import { Card } from "@ebsco-ui/ebsco-ui";
import PropTypes from "prop-types";
import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import { compose } from "redux";
import { ROUTES } from "../../../constants";
import sharedMessages from "../../../shared-messages";
import {
  expireSourceAccountCookies,
  getHasSourceAccountInfo,
  getMergeExecuteHasBeenRequested,
  resetValidationState
} from "../../store/merge";
import { getAccountDisplayName } from "../../store/personal-user";
import PageHeader from "../page-header";
import withPersonalization from "../with-personalization";
import WorkflowWizard, { WizardStep } from "../workflow-wizard";
import MergeExecution from "./execution";
import SourceSignIn from "./source-sign-in";
import MergeValidation from "./validation";

import "./merge-accounts.scss";

const block = "merge-accounts";

const MergeAccounts = ({
  intl: { formatMessage },
  hasExecuteMergeBeenRequested,
  hasSourceAccountInfo,
  username,
  expireSourceAccountCookies,
  resetValidationState
}) => {
  const mergeAccountsTitle = formatMessage(sharedMessages.mergeAccounts);
  const { search } = useLocation();
  const returnUrl = `${ROUTES.ACCOUNT_UPDATE}${search || ""}`;

  React.useEffect(() => {
    return () => {
      expireSourceAccountCookies();
      resetValidationState();
    };
  }, [expireSourceAccountCookies, resetValidationState]);

  return (
    <main className={block}>
      <PageHeader
        returnUrl={returnUrl}
        isExternalLink={false}
        returnLinkText={formatMessage(sharedMessages.backToMyAccount)}
        pageTitleText={mergeAccountsTitle}
      />
      <Card
        className={`${block}__card`}
        border="all"
        isRounded={true}
        isRaised={true}
        isTransparent={false}
      >
        <WorkflowWizard title={mergeAccountsTitle}>
          <WizardStep
            isStepComplete={hasSourceAccountInfo}
            component={SourceSignIn}
            username={username}
          />
          <WizardStep
            isStepComplete={hasExecuteMergeBeenRequested}
            component={MergeValidation}
          />
          <WizardStep isStepComplete={false} component={MergeExecution} />
        </WorkflowWizard>
      </Card>
    </main>
  );
};

MergeAccounts.propTypes = {
  hasExecuteMergeBeenRequested: PropTypes.bool.isRequired,
  hasSourceAccountInfo: PropTypes.bool.isRequired,
  returnUrl: PropTypes.string
};

const mapStateToProps = state => ({
  hasExecuteMergeBeenRequested: getMergeExecuteHasBeenRequested(state),
  hasSourceAccountInfo: getHasSourceAccountInfo(state),
  username: getAccountDisplayName(state)
});

const mapDispatchToProps = { expireSourceAccountCookies, resetValidationState };

export { MergeAccounts };
export default compose(
  withPersonalization,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(MergeAccounts);
